import React from 'react'

const PointTrackerRoute = ({children}) => {
  return children
}

export default PointTrackerRoute